import { http } from '../../../../api/http';
import type { PLAMEPreview } from '../types/plame';

const ENDPOINT = '/planilla/plame';

export class PLAMEService {
  static async preview(idPlanilla: number): Promise<PLAMEPreview> {
    const response = await http.get(`${ENDPOINT}/preview/${idPlanilla}`);
    return response.data;
  }

  static async exportZip(idPlanilla: number): Promise<void> {
    const response = await http.get(`${ENDPOINT}/export/${idPlanilla}`, {
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    const contentDisposition = response.headers['content-disposition'];
    const filename = contentDisposition
      ? contentDisposition.split('filename=')[1]?.replace(/"/g, '')
      : `PLAME_${idPlanilla}.zip`;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
